import {
  createContext,
  useContext,
  useState,
  useEffect,
  PropsWithChildren,
  useMemo,
} from 'react';

interface RegionContextType {
  isSelectedRegion: boolean;
  setIsSelectedRegion: (region: boolean) => void;
}

const RegionContext = createContext<RegionContextType | undefined>(undefined);

export const useRegion = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};

export const RegionProvider = ({ children }: PropsWithChildren) => {
  const [isSelectedRegion, setIsSelectedRegion] = useState<boolean>(
    !!localStorage.getItem('selectedRegion'),
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setIsSelectedRegion(!!localStorage.getItem('selectedRegion'));
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const contextValue = useMemo(
    () => ({ isSelectedRegion, setIsSelectedRegion }),
    [isSelectedRegion],
  );

  return (
    <RegionContext.Provider value={contextValue}>
      {children}
    </RegionContext.Provider>
  );
};
